import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Col, Container, Row } from 'react-bootstrap'
import Loader from '../component/Loader'
import CartService from '../services/Cart'
import Table from 'react-bootstrap/Table';
import { Trash2 } from 'react-feather';
import DefaultImage from '../assets/images/productDefault.png'
import { Plus } from 'react-feather';
import { Minus } from 'react-feather'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import ModalComponent from '../component/ModalComponent'
import OrderService from '../services/Order'
import { useNavigate } from 'react-router-dom'
import ConfirmationModal from '../component/ConfirmationModal'
import Modal from 'react-bootstrap/Modal';
import InputField from '../component/InputField'
import UploadFile from '../component/UploadFile'
import PrimaryOutLineButton from '../component/PrimaryOutLineButton'
import AlertMsg from '../component/AlertMsg'
import { useDispatch } from 'react-redux';
import { addTotalCartItems } from '../redux/slices/countSlice'
import { useSelector } from 'react-redux'
import toast from 'react-hot-toast'
import NoData from '../component/NoData'
import DOMPurify from "dompurify";
import { parseSafeHtml } from "../utils/safeHtmlParser";

const Cart = () => {
    //Cart No update Use Dispatch
    const tokens =  useSelector(
        state => state.userTypeSlice.token,
      );
    const totalCartItems = useSelector(
        state => state.countSlice.cartCount,
      );
    const dispatch = useDispatch()
    const [cartList, setCartList] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isPanVerifyModalOpen, setIsPanVerifyModalOpen] = useState(false)
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [isPanUploadModal, setIsPanUploadModal] = useState(false);
    const [show, setShow] = useState(false);
    const [isPANUpdateNo, setIsPANUploadNo] = useState('')
    const [isLoginSuccess, setIsLoginSuccess] = useState({ isLogin: true, heading: '', text: '' })
    const [showAlert, setShowAlert] = useState(false);
    const [removeShowAlert, setRemoveShowAlert] = useState(false);
    const [panImage, setPanImage] = useState(null);
    const [isPANValidation, setIsPANValidaton] = useState('')
    const [isPANImageValidation, setIsPANImageValidaton] = useState('')
    const [isCartData, setIsCartData] = useState(false)
    const [loading, setLoading] = useState(true);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [allPoints, setAllPoints] = useState({});
    const [panStatus, setPanStatus] = useState(0);

    const navigate = useNavigate()
    // Cart Badge  Update 
    const badgeUpdate = (itemArray) => {
        let sum = 0;
        if (itemArray.length > 0) {
            itemArray.forEach(item => {
                sum += parseInt(item.quantity)
            })
        }

        dispatch(addTotalCartItems({
            cartCount: sum
        }))
    }
    useEffect(() => {
        const CartFetchData = async () => {
            try {
                // const token = localStorage.getItem('access_token');
                const CartFetchDataResponse = await CartService.myCartItems();
                console.log("CartFetchDataResponse", CartFetchDataResponse)
                setLoading(false)
                setAllPoints(CartFetchDataResponse.data?.cart_data.control);
                if (CartFetchDataResponse.data && CartFetchDataResponse.data?.cart_data && CartFetchDataResponse.data.cart_data.row_items) {
                    const cartItemsObject = Object.keys(CartFetchDataResponse.data?.cart_data.row_items)
                    if (cartItemsObject.length > 0) {
                        const cartItemArray = cartItemsObject.map(key => CartFetchDataResponse.data?.cart_data.row_items[key]);
                        console.log("cartItemArray", cartItemArray)
                        setCartList(cartItemArray);
                        // setLoading(false)
                    } else {
                        setIsCartData(true);
                    }
                } else {
                    setIsCartData(true);
                    setLoading(false);
                }
            }
             catch (error) {
                console.error("CartFetchData");
                setIsCartData(true);
            }
        };

        CartFetchData();

    }, []);
    //Cart Remove
    const handleRemove = async (product_id) => {
        try {

            const token = localStorage.getItem('access_token');
            const payload = {
                product_id: product_id
            };
            const res = await CartService.deleteItem(payload, token)
            if (res.error == false) {
                updateCartItems();
                toast.success(res.apiResponse);
                // setRemoveShowAlert(true)
                // setIsLoginSuccess({ isLogin: !res.error, text: res.apiResponse })
                // setTimeout(() => {
                //     setRemoveShowAlert(false)
                // }, 2000)
            }

        }
        catch (error) {
            console.error("Item Removed")
        }

    }

    //Update Cart Info
    const updateCartItems = async () => {
        try {
            const token = localStorage.getItem('access_token');
            const CartFetchDataResponse = await CartService.myCartItems(token);
            if (JSON.stringify(CartFetchDataResponse.data) != '{}' && CartFetchDataResponse.data.cart_data && CartFetchDataResponse.data.cart_data.row_items) {
                const cartItemsObject = Object.keys(CartFetchDataResponse.data?.cart_data.row_items)
                const cartItemArray = cartItemsObject.map(key => CartFetchDataResponse.data?.cart_data.row_items[key])
                
                setCartList(cartItemArray)
                badgeUpdate(cartItemArray)
                setLoading(false)
            }
            else {
                setIsCartData(true);
                setCartList([]);
                badgeUpdate([]);
                setLoading(false)
            }

        } catch (error) {
            console.error("CartFetchData");
            setLoading(false)
        }
    }
    //Increment
    const handleIncrement = async (Selecteditem) => {
        const updatedItem = { ...Selecteditem, quantity: parseInt(Selecteditem.quantity) + 1 }
        const updatedCartList = cartList.map((item, index) => {
            if (item.product_id == Selecteditem.product_id)
                return (
                    {
                        prod_id: updatedItem.product_id,
                        quantity: updatedItem.quantity
                    }
                )
            else {
                return (
                    {
                        prod_id: item.product_id,
                        quantity: item.quantity
                    }
                )
            }
        })
        try {
            const token = localStorage.getItem('access_token');
            const payload = { product_arr: updatedCartList }
            const res = await CartService.updateCart(payload, token)
            if (!res.error) {
                const updatedCartData = cartList.map(item => ({
                    ...item,
                    quantity:
                        item.product_id == updatedItem.product_id
                            ? updatedItem.quantity + ''
                            : item.quantity + '',
                }));

                setCartList(updatedCartData)
                badgeUpdate(updatedCartData)
            }

        }
        catch (error) {
            console.error("Add Cart")
        }

    }
    //Decrement
    const handleDecrement = async (Selecteditem) => {
        if (Selecteditem.quantity <= 1) {
            return;
        }
        const updatedItem = { ...Selecteditem, quantity: parseInt(Selecteditem.quantity) - 1 }
        const updatedCartList = cartList.map((item, index) => {
            if (item.product_id == Selecteditem.product_id)
                return (
                    {
                        prod_id: updatedItem.product_id,
                        quantity: updatedItem.quantity
                    }
                )
            else {
                return (
                    {
                        prod_id: item.product_id,
                        quantity: item.quantity
                    }
                )
            }
        })
        try {
            const token = localStorage.getItem('access_token');
            const payload = { product_arr: updatedCartList }
            const res = await CartService.updateCart(payload, token)
            if (!res.error) {
                const updatedCartData = cartList.map(item => ({
                    ...item,
                    quantity:
                        item.product_id == updatedItem.product_id
                            ? updatedItem.quantity + ''
                            : item.quantity + '',
                }));
                
                setCartList(updatedCartData)
                badgeUpdate(updatedCartData)
            }
        }
        catch (error) {
            console.error("Add Cart")
        }
    }

    const handleShowModal = (event) => {
        setSelectedEvent(event);
        setIsModalOpen(true);
    };
    const handlePANVerifyShowModal = (event) => {
        setSelectedEvent(event);
        setIsPanVerifyModalOpen(true);
    };
    const checkPan = () => {
        OrderService.panCheck({cart_value: allPoints.grandtotalprice})
          .then(res => {
            if (!res?.error) {
              setPanStatus(res?.pan_status);
              if (res?.pan_status == '1' || res?.pan_status == 1) {
                // has pan already
                navigate('/address-list');
              } else {
                // setQuestionModalOpen(true);
                handleShowModal()
              }
            } else {
             
            }
          })
          .catch(err => {
          });
      };
    const handlePlaceOrder = () => {
        checkPan();

    }
    const setPanHandler = (pan) => {
        setPanImage(pan)
        setIsPANImageValidaton("");
    }
    const handleOptionSelection = (response) => {
        if (response == 'Yes') {
            setIsPanVerifyModalOpen(false)
            setIsPanUploadModal(true)
            setShow(true)
        }
        else if (response == 'No') {
            setIsPanVerifyModalOpen(false);
            navigate(`/address-list`);
        }
    }
    const handleClose = () => setShow(false);
    //EKYC Verification & Page Proceed
    const onContinue = async () => {
       navigate("/dynamic-ekyc",  {state: {type: 'pan', from: 'cart'}})
    }
    
    
    //PAN Upload
    const handleNewPANUpload = async () => {
        let isVerify = true;
        if (!isPANUpdateNo) {
            setIsPANValidaton("PAN Card No is required");
            isVerify = false

        }

        if (!panImage) {
            setIsPANImageValidaton("PAN Image is required");

        }
        if (isVerify) {
            const kycUpdateData = new FormData();
            kycUpdateData.append('ambujaPanTypeId', '2');
            kycUpdateData.append('panCardNumber', isPANUpdateNo);
            kycUpdateData.append('pan_image', panImage.file)
            const token = localStorage.getItem('access_token');
            setIsButtonLoading(true)
            const UpdateKYC = await OrderService.panUpdate(kycUpdateData, token)
            
            setIsButtonLoading(false)
            if (UpdateKYC.data.status) {
                setShow(false);
                toast.success(UpdateKYC.data.message);

            }
            else {
                // setShowAlert(true)
                // setIsLoginSuccess({ isLogin: false, text: UpdateKYC.data.message })
                // setTimeout(() => {
                //     setShowAlert(false)
                // }, 2000)
                toast.error(UpdateKYC.data.message);

            }
        }

    }
    const handlePANUpload = (e) => {
        setIsPANUploadNo(e.target.value)
        const idRegex = /^[A-Z]{5}\d{4}[A-Z]$/; // PAN card regex
        if (!idRegex.test(e.target.value)) {
            setIsPANValidaton("Invalid PAN card number.");
        } else {
            setIsPANValidaton(""); // Reset error message if validation passes
        }
    }

    function onLeftBtnClick() {
        navigate("/address-list")
    }
    return (
        <>
            {loading && <Loader />}
            <BreadCrumbSecttion
                pageTitle="Cart"
                currentPageName="Cart" />
            <section className='padTop50'>
                <div className="dashboard-details">
                    <Container>
                    {/* {cartList.length === 0 && !loading && <NoData />} */}
                        <Row>
                            {isCartData ? (
                                <div className="error-message mb-4"><NoData title='Your cart is empty' /></div>
                            ) : (<>

                                <Col xs={12} lg={6} className='mb-4'>

                                    {removeShowAlert && <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                        heading={isLoginSuccess.heading}
                                        text={isLoginSuccess.text}
                                    />
                                    }

                                </Col>
                                <Col xs={12}>

                                    <Table striped bordered hover responsive>
                                        <thead>
                                            <tr>
                                                <th>Product Image</th>
                                                <th>Product Name</th>
                                                <th>Description</th>
                                                <th>Points</th>
                                                <th>Quantity</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cartList?.map((item, index) => {
                                                const { product_image, product_id, product_name, product_desc, quantity } = item;
                                                const imgSrc = product_image.length > 0 ? product_image : DefaultImage;
                                                return (
                                                    <tr key={index}>
                                                        <td className='text-center'>
                                                            <div className='cartProductImage'>
                                                                <img src={imgSrc} alt='image' />
                                                            </div>
                                                        </td>
                                                        {/* <td>{product_name}</td> */}
                                                        <td className="align-middle text-center">{product_name}</td>

                                                        {/* <td className="align-middle text-center">{<div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(product_desc)}} />}</td> */}
                                                        <td className="align-middle text-center">{<div>{parseSafeHtml(product_desc)}</div>}</td>

                                                        <td className="align-middle text-center">{item.price_in_points} Points</td>

                                                        <td><div className='quantityBox'>
                                                            <div className='quantityMinus'
                                                                onClick={() => { handleDecrement(item) }}><Minus /></div>

                                                            <div className='quantityBoxNum'>{quantity}</div>
                                                            <div className='quantityPlus'
                                                                onClick={() => { handleIncrement(item) }}><Plus /></div>
                                                        </div>
                                                        </td>
                                                        <td className='text-center'><Trash2 color="red" size={20}
                                                            onClick={() => { handleRemove(product_id) }} className='trashIcon' /></td>
                                                    </tr>
                                                );
                                            })}

                                        </tbody>
                                    </Table>

                                </Col>
                                <Col xs={12}>
                                    <div className='buttonWrap my-4'>
                                        <PrimaryGradientButton buttonText="Place Order" onClick={handlePlaceOrder} />
                                    </div>
                                </Col>
                            </>
                            )}
                            < Col xs={12}>
                                <ModalComponent
                                    page="cart"
                                    isModalOpen={isModalOpen}
                                    setIsModalOpen={setIsModalOpen}
                                    outlinebuttonText="Continue"
                                    buttonText="No"
                                    onClick={onContinue}
                                    onLeftBtnClick={onLeftBtnClick}
                                    modalTitle="Please read the following"
                                    modalQuestion="Do you want to upload PAN?"
                                    panStatus={panStatus}
                                    modalDescription="Dear Member, Income Tax Department has introduced Section 194R, according to which, if your redemption value is equal or more than Rs. 20,000/-, then in the financial year in the absence of PAN number, the rate of 20% of the total redeemed value. There will be tax reduction. 
                                        If your PAN is available then you are requested to please contact your Officer or call 18001037417
                                        प्रिय सदस्य, आयकर विभाग ने धारा 194 आर प्रविष्ट की है, जिसके अनुसार, यदि आपका रिडेम्पशन मूल्य रुपये 20,000/- के सम या अधिक है, तो वित्तीय वर्ष में पैन संख्या के अभाव में कुल भुनाए गए मूल्य के 20% की दर से कर कटौती होगी।

                                        यदि आपका पैन उपलब्ध है तो आपसे अनुरोध है कि कृपया अपने अधिकारी से संपर्क करें या 18001037417 पर कॉल करे"/>
                            </Col>
                            <Col xs={12}>
                                <ConfirmationModal
                                    page="eKYCResponse"
                                    onClick={handleOptionSelection}
                                    isModalOpen={isPanVerifyModalOpen}
                                    setIsModalOpen={setIsPanVerifyModalOpen}
                                    modalTitle="Do You Have PAN Card?" />

                            </Col>
                            <Col xs={12}>

                                {isPanUploadModal && (<Modal show={show} onHide={handleClose}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Please Fill Your PAN Details</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <InputField
                                            requiredStar="*"
                                            inputFieldLabel="PAN No"
                                            value={isPANUpdateNo}
                                            onChange={handlePANUpload} />
                                        {isPANValidation && <div className="error-message mb-4">{isPANValidation}</div>}
                                        <UploadFile label="Upload PAN" requiredStar="*" accept="image/*" value={panImage}
                                            setValue={setPanHandler} />
                                        {isPANImageValidation && (
                                            <div className="error-message mb-4">
                                                {isPANImageValidation}
                                            </div>
                                        )}
                                        <PrimaryOutLineButton outlinebuttonText={isButtonLoading ? "Processing..." : "Submit"} onClick={handleNewPANUpload} disabled={isButtonLoading} />
                                        <div className='mt-4'>
                                            {showAlert && <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                                heading={isLoginSuccess.heading}
                                                text={isLoginSuccess.text}
                                            />
                                            }
                                        </div>

                                    </Modal.Body>
                                    <Modal.Footer>

                                        <PrimaryGradientButton buttonText="Close" onClick={handleClose} />
                                    </Modal.Footer>
                                </Modal>)
                                }
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section >
        </>
    )
}

export default Cart